<mat-list-item class="mt-0 pt-0" [ngClass]="venta.entregado == false || venta.entregado == null ? 'sin-entregar' : '' " id="sale">
    <div matLine (click)="viewSale(venta._id)">
        <span class="h6">{{venta.cliente}},</span>
        <span class="pl-2 text-info text-small"> el {{venta.fecha | date: 'dd/MM/yyyy'}}</span>
    </div>

    <span class="demo-2 pr-2" (click)="viewSale(venta._id)"> {{venta.monto | currency: '$'}} </span>
    <mat-icon (click)="deleteSale(venta._id)">delete_outline</mat-icon>
    <mat-icon (click)="editSale(venta._id)">edit</mat-icon>

    <div matLine>
        <span (click)="setEntrega(venta)" class="badge badge-success" *ngIf="venta.entregado">Entregado</span>
        <span (click)="setEntrega(venta)" class="badge badge-danger" *ngIf="!venta.entregado">Sin entregar</span>
        <span class="demo-2 pl-2 text-info text-small"> {{venta.pedido}} </span>
    </div>
    <mat-divider></mat-divider>
</mat-list-item>
